import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { JobRead } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

import { jobIsRunning } from "../utils/job-is-running";

// Single

const getJobLogsQuery = (job: JobRead | undefined) => {
  const jobId = job?.id;
  const status = job?.state.type;
  return getRanaApiV1().getQueryOptions({
    queryKey: ["process-logs", jobId, status],
    queryFn: async () => {
      if (!jobId) throw new Error("never happens");

      return getRanaApiV1().JobsApi.jobLogs({ jobId });
    },
    refetchInterval: () => jobIsRunning(status) && 2000,
    placeholderData: keepPreviousData,
    enabled: !!jobId,
  });
};

export const useJobLogsQuery = (job: JobRead | undefined) => {
  return useQuery(getJobLogsQuery(job));
};
